import { updateItems } from './mockData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 mb-4">
              <i className="ri-flashlight-line text-accent-600 text-sm"></i>
              <span className="text-accent-700 text-xs font-medium">实时快讯</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              关注555电影网最新内容更新与平台动态
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-200"></div>

            <div className="space-y-8">
              {updateItems.map((item, idx) => (
                <div key={item.id} className="relative pl-12 md:pl-16">
                  <div className={`absolute left-2 md:left-4 w-5 h-5 rounded-full border-2 ${
                    idx === 0
                      ? 'bg-primary-500 border-primary-500'
                      : 'bg-background-50 border-primary-300'
                  }`}></div>

                  <div className="bg-background-100 rounded-xl p-5 md:p-6">
                    <div className="flex flex-wrap items-center gap-3 mb-2">
                      <span className={`inline-block px-2.5 py-0.5 rounded-md text-xs font-medium whitespace-nowrap ${
                        item.tag === '新片上线' || item.tag === '重磅上线'
                          ? 'bg-primary-100 text-primary-700'
                          : item.tag === '专题推荐' || item.tag === '内容更新'
                          ? 'bg-accent-100 text-accent-700'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}>
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{item.date}</span>
                    </div>
                    <h3 className="font-bold text-foreground-900 text-sm md:text-base mb-1">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}